export const ghostLink = (url) => {
  const link = document.createElement("a");
  link.target = "_blank";
  link.href = url;
  link.click();
};
